import Page from '@modules/cms/pages/default';

export default Page;
